import { Flex, Grid, Space, Typography } from "antd";
import { FC } from "react";

interface authTitleAndDescriptionProps {
  titleAndDescription: { title: string; description: string };
}

const AuthTitleAndDescription: FC<authTitleAndDescriptionProps> = ({
  titleAndDescription,
}) => {
  const { title, description } = titleAndDescription || {
    title: "",
    description: "",
  };
  const { Title, Paragraph, Text } = Typography;
  const { useBreakpoint } = Grid;
  const screen = useBreakpoint();

  return (
    //     <div className="text-center space-y-[16px] ">
    //     <h3 className="font-semibold  text-main-title text-[18px] sm:text-[24px]">
    //         {title}
    //     </h3>
    //     <p className="text-sec-title">{description}</p>
    // </div>
    <Flex vertical gap={"16px"} align="center" className=" ">
      <Title level={screen.md ? 2 : 3} className="">
        {title}
      </Title>
      <Paragraph className=" !m-0 text-center text-[#75757E]">
        {description}
      </Paragraph>
    </Flex>
  );
};

export default AuthTitleAndDescription;
